import React from 'react';
import { Icon } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import 'PointOfSale/styles/components/pageHeader.less';

const IconWithPrimarySecondaryLabel = props => {
  const {
    IconWidth,
    IconDivClassName,
    icon,
    IconClassName,
    textWidth,
    labelClassName,
    primaryLabel,
    primaryClassName,
    secondaryClassName,
    secondaryLabel,
  } = props;
  const classes = {
    IconDivClass: classNames('tableCell', {
      [IconDivClassName]: IconDivClassName ? true : false,
    }),
    IconClass: classNames({
      [IconClassName]: IconClassName ? true : false,
    }),
    labelClass: classNames('tableCell', {
      [labelClassName]: labelClassName ? true : false,
    }),
    primaryClass: classNames('primaryLabel', {
      [primaryClassName]: primaryClassName ? true : false,
    }),
    secondaryClass: classNames('secondaryLabel', {
      [secondaryClassName]: secondaryClassName ? true : false,
    }),
  };
  return (
    <div className="rootTable whiteColor">
      {IconWidth && (
        <div style={{ width: IconWidth }} className={classes.IconDivClass}>
          {icon && <Icon name={icon} className={classes.IconClass} />}
        </div>
      )}
      {textWidth && (
        <div style={{ width: textWidth }} className={classes.labelClass}>
          {primaryLabel && (
            <React.Fragment>
              <span key="sp1" className={classes.primaryClass}>
                {primaryLabel}
              </span>
              <br key="br11" />
            </React.Fragment>
          )}
          <span className={classes.secondaryClass}>{secondaryLabel}</span>
        </div>
      )}
    </div>
  );
};

IconWithPrimarySecondaryLabel.propTypes = {
  IconWidth: PropTypes.string,
  IconDivClassName: PropTypes.string,
  icon: PropTypes.string,
  IconClassName: PropTypes.string,
  textWidth: PropTypes.string,
  labelClassName: PropTypes.string,
  primaryLabel: PropTypes.string,
  primaryClassName: PropTypes.string,
  secondaryClassName: PropTypes.string,
  secondaryLabel: PropTypes.string,
};
export default IconWithPrimarySecondaryLabel;



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/layouts/component/servingOptions/IconWithPrimarySecondaryLabel.js